import { Games as DefaultGames } from './Games';

import { slotsWithState } from '../SlotGamesList';
import { withCatalogState } from '../GamesList';

export const GamesJune = slotsWithState(DefaultGames);
export const GamesDecember = withCatalogState(DefaultGames);
